import script from "./typicalCase.vue?vue&type=script&setup=true&lang=js"
export * from "./typicalCase.vue?vue&type=script&setup=true&lang=js"

import "./typicalCase.vue?vue&type=style&index=0&id=5db49318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db49318"]])

export default __exports__